class CsvImportManagement extends HTMLElement {
    constructor() {
        super();

        this.csvInfo = JSON.parse(localStorage.getItem('br_csv_import'));
        this.csvStatusInterval = null;
        this.loadingModal = this.querySelector('.br-loadingAsyncModal');
        this.errorMessageToast = this.querySelector('.br-messageToast.-error');
        this.successMessageToast = this.querySelector('.br-messageToast.-success');
        this.successMessageToastFull = this.querySelector('.br-messageToast.-success p.fullCsvMessage');
        this.successMessageToastPartial = this.querySelector('.br-messageToast.-success p.partialCsvMessage');

        this.initializeCsvPidListener();
        //this.initializeDropdownListener();
    }

    /* --------------------------- LISTENERS - METHODS -------------------------- */

    initializeCsvPidListener() {
        if (!this.csvStatusInterval && this.csvInfo !== null) {
            this.initializeCsvStatusInterval();
        }

        window.addEventListener('csv-import', () => {
            this.csvInfo = JSON.parse(localStorage.getItem('br_csv_import'));
            if (!this.csvStatusInterval && this.csvInfo !== null) {
                this.initializeCsvStatusInterval();
            }
        });
    }

    // initializeDropdownListener() {
    //     this.spinner.addEventListener('click', () => {
    //         this.dropdown.classList.toggle('-open');
    //     })
    // }
    // initializeCloseErrorsListener() {
    //     this.messageError.querySelector('.csvImport__dropdown-close').addEventListener('click', () => {
    //         this.messageError.classList.toggle('-open');
    //         this.loadCart();
    //     })
    // }

    /* --------------------------- INTERVAL - METHODS --------------------------- */

    initializeCsvStatusInterval() {
        this.loadingModal.style.display = 'flex';
        this.csvImportStatusManagement();

        this.csvStatusInterval = setInterval(async () => {
            this.csvImportStatusManagement();
        }, 10000);
    }

    clearCsvStatusInterval() {
        clearInterval(this.csvStatusInterval);
        this.csvStatusInterval = null;
    }

    /* --------------------------------- METHODS -------------------------------- */

    async csvImportStatusManagement() {
        const importInfo = await this.handleImportCsvAsyncStatus();

        if (importInfo.error) {
            this.clearCsvStatusInterval();
            this.parseErrors(importInfo.error);
            return;
        }

        if (importInfo.status === 'done') {
            this.clearCsvStatusInterval();
            this.loadCart(importInfo.data, importInfo.errors.length > 0);
        }
    }

    parseErrors(errors) {
        this.loadingModal.style.display = 'none';
        this.errorMessageToast.style.display = 'inherit';
        setTimeout(() => {
            this.errorMessageToast.style.display = 'none';
        }, [3000]);
        this.csvInfo = null;
        localStorage.removeItem('br_csv_import');
        // this.messageError.querySelector('.csvImport__error').querySelector('span').innerHTML = this.csvInfo.name;
        // this.dropdown.classList.remove('-open');
        // const errorsKeys = Object.keys(errors);
        // let messages = {};
        // const csvMessages = document.querySelector('#csvMessages');
        // if (csvMessages.innerHTML) {
        //     messages = JSON.parse(csvMessages.innerHTML);
        // } else {
        //     return;
        // }
        // const errorsUl = this.messageError.querySelector('ul');
        // errorsKeys.forEach(key => {
        //     const li = document.createElement('li');
        //     if(key === 'generic') {
        //         li.innerHTML = messages[key];
        //     } else {
        //         const [sku, size] = key.split('-');
        //         const errorKey = errors[key] && errors[key][0] && errors[key][0].message && errors[key][0].message.text || 'err_server'
        //         li.innerHTML = `<strong>${sku} ${size}:</strong> ${messages[errorKey] || messages['err_server']}`;
        //     }
        //     errorsUl.appendChild(li);
        // });

        // this.messageError.classList.add('-open');
        // this.initializeCloseErrorsListener();
    }

    async loadCart(items, hasErrors) {
        localStorage.removeItem('br_csv_import');
        setNewCart(items);
        this.successMessageToast.style.display = 'inherit';
        if (hasErrors) {
            this.successMessageToastPartial.style.display = 'block';
        } else {
            this.successMessageToastFull.style.display = 'block';
        }

        setTimeout(() => {
            this.csvInfo = null;
            window.location.href = '/cart';
        }, 3000);
    }

    /* ------------------------------ HTTP REQUEST ------------------------------ */

    async handleImportCsvAsyncStatus() {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');

        const requestOptions = {
            method: 'GET',
            headers: headers,
        };

        const response = await fetch(`/apps/berardi/orders/import/${this.csvInfo.pid}/status`, requestOptions);
        const data = await response.json();
        return data;
    }
}

customElements.define('csv-import-management', CsvImportManagement);
